import { NgModule } from '@angular/core';
import { BulmangularComponent } from './bulmangular.component';



@NgModule({
  declarations: [BulmangularComponent],
  imports: [
  ],
  exports: [BulmangularComponent]
})
export class BulmangularModule { }
